"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleChoiceItem = void 0;
const react_1 = __importStar(require("react"));
const MultipleChoiceItem_styles_1 = require("./MultipleChoiceItem.styles");
const constants_1 = require("../../helpers/constants");
const helpers_1 = require("../../../../Grid/cellRenderers/helpers");
const Text_1 = require("../../../../Text");
const Tooltip_1 = require("../../../../Tooltip");
exports.MultipleChoiceItem = react_1.default.memo(function MultipleChoiceItem({ data, column, row, onToggle, index, selected }) {
    const ref = (0, react_1.useRef)(null);
    const renderContent = (0, react_1.useCallback)(() => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, data.name), [data.name]);
    const onChange = (0, react_1.useCallback)(() => onToggle && onToggle(index), [index, onToggle]);
    return (0, Tooltip_1.useTooltip)({
        delayTimeout: 500,
        maxWidth: constants_1.DEFAULT_MAX_WIDTH_COLUMN,
        renderContent,
        render: (tooltipProps) => {
            return (react_1.default.createElement(MultipleChoiceItem_styles_1.StyledMultipleChoiceItem, { column: column, row: row, "data-selector-id": `multiplechoice-item-${index}` },
                react_1.default.createElement(MultipleChoiceItem_styles_1.StyledMultipleChoiceItemCheckbox, { ref: ref, checked: selected, labelTruncate: true, onChange: onChange, onMouseEnter: (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave, "data-selector-id": `multiplechoice-checkbox-${index}` }, data.name)));
        }
    });
});
//# sourceMappingURL=MultipleChoiceItem.js.map